import React, { ReactElement, useContext, useEffect, useState } from 'react';
import { useTheme } from '@mui/material';
import { AlertMessage } from '@eposnow/ui-core';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';
import { UIContext } from '../../context/UIContext';
import { UserContext } from '../../context/UserContext';

interface FeedbackBannerProps {
    text: string;
    leftButtonText: string;
    rightButtonText: string;
    iconElement?: React.ReactNode;
    onLeftAction?: () => void;
    onRightAction?: ()=> void;
}

const FeedbackBanner = ({
    text,
    leftButtonText,
    rightButtonText,
    iconElement,
    onLeftAction: action,
    onRightAction: action2,
}: FeedbackBannerProps) => {

    const theme = useTheme();
    const { isMobile, isTablet } = useContext(UIContext);
    const { locale } = useContext(UserContext);
    const { t } = useTranslation();    

    return (
        <AlertMessage type='info' locale={locale} theme={theme} styles={{ marginBottom: 2, marginTop: '-23px', marginLeft: '-23px', marginRight: '-23px' }} iconAlignment='center' isMobile={isMobile || isTablet}>
            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <Typography sx={{ marginTop: '12px' }}>{text}</Typography>
                <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                    <Button data-qa-id="gotItButton" sx={{ marginLeft: 'auto', fontWeight: 'bold', color: theme.palette.info.dark }} onClick={action}>
                        {leftButtonText}
                    </Button>
                    <Button data-qa-id="feedbackButton" sx={{ marginLeft: 'auto', fontWeight: 'bold', color: theme.palette.info.dark }} onClick={action2}>
                        {iconElement}{rightButtonText}
                    </Button>
                </Box>
            </Box>
        </AlertMessage>
    );
}

export default FeedbackBanner;
